module.exports = __webpack_public_path__ + "img/next-steps.1cc2156b.svg";